import React from 'react';
import { clsx } from 'clsx';

interface QuickBadgeProps {
  variant?: 'bestseller' | 'limited' | 'premium' | 'new';
  className?: string;
}

const getBadgeConfig = (variant: string) => {
  switch (variant) {
    case 'bestseller':
      return { icon: '🏅', label: 'POPULAR', bg: 'bg-blue-100', text: 'text-blue-700' };
    case 'limited':
      return { icon: '⚡', label: 'LIMITADO', bg: 'bg-amber-100', text: 'text-amber-700' };
    case 'premium':
      return { icon: '👑', label: 'PREMIUM', bg: 'bg-purple-100', text: 'text-purple-700' };
    case 'new':
      return { icon: '✨', label: 'NUEVO', bg: 'bg-green-100', text: 'text-green-700' };
    default:
      return { icon: '', label: '', bg: '', text: '' };
  }
};

/**
 * Badge compacto para diferenciadores de productos
 * Proporciona contexto visual rápido sobre el ataúd
 */
const QuickBadge: React.FC<QuickBadgeProps> = ({ 
  variant, 
  className = '' 
}) => {
  if (!variant) return null;
  
  const config = getBadgeConfig(variant);
  
  return (
    <div className={clsx(
      'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold',
      config.bg,
      config.text,
      className
    )}>
      <span className="text-sm">{config.icon}</span>
      <span>{config.label}</span>
    </div>
  );
};

export default QuickBadge;
